module.exports = __webpack_public_path__ + "img/imgsierrab.0cc9c019.png";